import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import events, {
  EVENT_DASHBOARD_COMMIT_LOADED,
  EVENT_LANGUAGE_CHANGED,
  EVENT_PURCHASE_CLAIM_CLOSED,
} from './events';

import {
  getCurrentUserMembership,
} from '../selectors/purchase-selector';

export default (state) => {
  const dispatchEvent = (name, data) => {
    const { session: { authentication }, purchases: { current } } = state;
    return events.publish(name, { entityId: current, entityType: 'Purchase'}, data, authentication);
  };

  return {
    dispatchDashboardCommitLoadedEvent() {
      const currentMembership = getCurrentUserMembership(state) || {};
      const data = {
        committedStatus: currentMembership.status,
        failed: currentMembership.failed,
        short: currentMembership.short,
        claimedSlots: currentMembership.claimedSlots,
        maxShareAmount: currentMembership.maxShareAmount,
      };
      return dispatchEvent(EVENT_DASHBOARD_COMMIT_LOADED, data);
    },
    dispatchLanguageChangedEvent(language) {
      const data = {
        selectedLanguage: language,
        currentPage: window.location.pathname,
      };

      return dispatchEvent(EVENT_LANGUAGE_CHANGED, data);
    },
    dispatchPurchaseClaimClosed(formName) {
      const currentValues = get(state, `form.${formName}.values`, {});
      const inviteeFields = {inviteesWithEmail: 0, inviteesWithName: 0, inviteesWithShareAmount: 0};
      currentValues.invitees.forEach((inv) => {
        inviteeFields.inviteesWithEmail += !isEmpty(inv.email) ? 1 : 0;
        inviteeFields.inviteesWithName += !isEmpty(inv.fullName) ? 1 : 0;
        inviteeFields.inviteesWithShareAmount += inv.allowedShareAmount.amountCents !== 0 ? 1 : 0;
      });
      const data = {
        formValues: {
          splitType: currentValues.splitType,
          minSlots: currentValues.minSlots,
          orgEmailEntered: !isEmpty(currentValues.organizerEmail),
          orgNameEntered: !isEmpty(currentValues.organizerName),
          orgPasswordEntered: !isEmpty(currentValues.organizerPassword),
          ...inviteeFields,
        },
      };
      return dispatchEvent(EVENT_PURCHASE_CLAIM_CLOSED, data);
    }
  };
};



// WEBPACK FOOTER //
// ./src/lib/event-dispatcher.js